import { render, staticRenderFns } from "./Cloud-exhibition-detail.vue?vue&type=template&id=93b40ea6&scoped=true&"
import script from "./Cloud-exhibition-detail.vue?vue&type=script&lang=js&"
export * from "./Cloud-exhibition-detail.vue?vue&type=script&lang=js&"
import style0 from "./Cloud-exhibition-detail.vue?vue&type=style&index=0&id=93b40ea6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93b40ea6",
  null
  
)

export default component.exports